import React from 'react';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';
import { EIconTypes } from 'constants/Icons';
import {
  ICase,
  ICaseFormValues,
  ICaseHistory,
  ICaseAttachmentResponse,
  IAttachment,
  INote,
  ITask,
  ITaskComment,
  IReports,
  ICaseLicence,
  ECaseRenewalStatus,
  ECaseVariationStatus,
} from 'models/cases';
import { ITableColumns, ITableDataSource } from 'models/table';
import { formatDate } from 'utils/date';
import { colors } from 'theme/colors';
import { Chips, EChipsVariants } from 'components/atoms/Chips';
import Icon from 'components/atoms/Icon/Icon';
import { Grid, Link, Typography } from '@mui/material';
import { StyledIconWrapper } from './styles';
import { AccordionItem } from 'components/molecules/CustomizedAccordions';
import { MenuButton } from 'components/molecules/MenuButton';
import { IDictionary } from 'models/dictionary';
import { findInDictionary } from 'helpers/dictionary';
import { ERouteLinks } from 'models/route';
import { ELegalEntityTypes, LETypes } from 'constants/LegalEntityTypes';
import { ElabelsCaseManagement, renderStatusCaseFieldColor } from '../helpers';
import { ETabId } from '..';
import Tooltip from 'components/atoms/Tooltip';
import { EPaymentStatusId } from 'pages/LegalEntitiesPage/helpers';
import { ETaskStatus } from 'constants/Case';
import { renderLicenceDataColor } from 'components/molecules/Table/helpers';

export enum Elabels {
  caseGeneralInformation = 'caseManagement.cases.generalInformation.label',
  verificationProcess = 'caseManagement.cases.verificationProcess.label',
  application = 'caseManagement.cases.application.label',
  attachments = 'caseManagement.cases.attachments.label',
  request = 'caseManagement.cases.request.label',
  licences = 'caseManagement.cases.licences.label',
  comments = 'caseManagement.cases.comments.label',
  totalThreads = 'caseManagement.cases.totalThreads.label',
  tasks = 'caseManagement.cases.tasks.label',
  applicationData = 'caseManagement.cases.applicationData.label',
  history = 'caseManagement.cases.history.label',
  documents = 'caseManagement.cases.documents.label',
  intelligenceReport = 'caseManagement.cases.intelligenceReport.label',
  notes = 'caseManagement.cases.notes.label',
  notesText = 'caseManagement.cases.notes.text',
  caseNoteAddHeader = 'caseManagement.cases.addNote.text',
  licencesTabText = 'caseManagement.cases.licencesTabText.text',

  addTask = 'caseManagement.cases.addTask.label',
  addNote = 'caseManagement.cases.addNote.label',

  editTask = 'caseManagement.cases.editTask.label',
  viewTask = 'caseManagement.cases.viewTask.label',
  taskName = 'caseManagement.cases.taskName.label',
  taskStatus = 'caseManagement.cases.taskStatus.label',
  taskDescription = 'caseManagement.cases.taskDescription.label',
  taskSummary = 'caseManagement.cases.taskSummary.label',
  deleteTask = 'caseManagement.cases.deleteTask.label',
  deleteTaskConfirm = 'caseManagement.deleteTask.confirm.text',
  results = 'caseManagement.results.text',
  addResults = 'caseManagement.addResults.text',
  submitUpdate = 'caseManagement.submitUpdate.text',
  addIntelligenceReport = 'caseManagement.cases.addReport.label',
  addDocument = 'caseManagement.addDocument.text',

  casesHeader = 'caseManagement.cases.casesHeader.label',
  caseDetailsHeader = 'caseManagement.cases.caseDetailsHeader.label',
  reprintEnqueued = 'caseManagement.cases.reprintEnqueued.message',
  reprintSent = 'caseManagement.cases.reprintSent.message',
  reprintLicenceModalTitle = 'caseManagement.cases.reprintLicence.modalTitle.label',
  reprintLicenceSelectLicence = 'caseManagement.cases.reprintLicence.selectLicence.text',
  reprintLicenceLicence = 'caseManagement.cases.reprintLicence.licence.label',
  reprintLicenceSuccess = 'caseManagement.cases.reprintLicence.success.message',
  reprintedLicence = 'caseManagement.cases.reprintedLicence.label',
  caseNoteDetailsHeader = 'caseManagement.cases.caseNoteDetailsHeader.label',
  editIntelligenceReport = 'caseManagement.cases.editIntelligenceReport.label',
  remove = 'caseManagement.cases.remove.label',
  edit = 'caseManagement.cases.edit.label',
  assign = 'caseManagement.cases.assign.label',
  reprint = 'caseManagement.cases.reprint.label',
  assignSelectedCase = 'caseManagement.cases.assignSelectedCase.text',
  reassign = 'caseManagement.cases.reassign.label',
  verifyTheCase = 'caseManagement.cases.verifyTheCase.label',
  updatePayment = 'caseManagement.cases.updatePayment.label',

  reason = 'caseManagement.cases.reason.label',
  approve = 'caseManagement.cases.approve.label',
  refuse = 'caseManagement.cases.refuse.label',

  caseApproval = 'caseManagement.cases.caseApproval.label',
  caseRefusal = 'caseManagement.cases.caseRefusal.label',

  processType = 'caseManagement.cases.processType.label',
  legalEntityType = 'caseManagement.cases.legalEntityType.label',
  legalEntityName = 'caseManagement.cases.legalEntityName.label',
  createDate = 'caseManagement.cases.createDate.label',
  assignedWorker = 'caseManagement.cases.assignedWorker.label',
  caseID = 'caseManagement.cases.caseId.label',
  assignedResource = 'caseManagement.cases.assignedResource.label',
  timeSinceCreation = 'caseManagement.cases.timeSinceCreation.label',
  decisionDate = 'caseManagement.cases.decisionDate.label',

  addComment = 'caseManagement.cases.addComment.label',
  addAttachment = 'caseManagement.cases.addAttachment.label',
  fileName = 'caseManagement.cases.fileName.label',
  description = 'caseManagement.cases.description.label',
  conclusions = 'caseManagement.cases.conclusions.label',
  instructions = 'caseManagement.cases.instructions.label',
  creationDate = 'caseManagement.cases.creationDate.label',
  message = 'caseManagement.cases.message.label',
  comment = 'caseManagement.cases.comment.label',
  topic = 'caseManagement.cases.topic.label',
  documentName = 'caseManagement.cases.documentName.label',
  importanceNotice = 'caseManagement.cases.importanceNotice.label',
  filename = 'caseManagement.cases.filename.column.label',
  noFilesAdded = 'caseManagement.cases.noFilesAdded.label',
  downloadAll = 'caseManagement.cases.downloadAll.label',
  uploadDocument = 'caseManagement.cases.uploadDocument.label',

  task = 'caseManagement.cases.task.label',
  info = 'caseManagement.cases.info.label',
  status = 'caseManagement.cases.status.label',
  actions = 'caseManagement.cases.actions.label',

  sourceSystem = 'caseManagement.cases.sourceSystem.label',
  trace = 'caseManagement.cases.trace.label',
  lastUpdate = 'caseManagement.cases.lastUpdate.label',
  lastAuthor = 'caseManagement.cases.lastAuthor.label',
  notesName = 'caseManagement.cases.notesName.label',
  attachment = 'caseManagement.cases.attachment.label',
  user = 'caseManagement.cases.user.label',

  event = 'caseManagement.cases.event.label',
  author = 'caseManagement.cases.author.label',
  dateTime = 'caseManagement.cases.dateTime.label',

  worker = 'caseManagement.cases.worker.label',

  licenceName = 'caseManagement.cases.licenceName.label',
  userType = 'caseManagement.cases.userType.label',
  cityStateProvince = 'caseManagement.cases.cityStateProvince.label',
  assignTo = 'caseManagement.cases.assignTo.label',
  assignedTo = 'caseManagement.cases.assignedTo.label',
  assignCase = 'caseManagement.cases.assignCase.label',
  closeCase = 'caseManagement.cases.closeCase.label',
  closeTask = 'caseManagement.cases.closeTask.label',
  addDecision = 'caseManagement.cases.addDecision.label',
  reprintLicence = 'caseManagement.cases.reprintLicence.label',
  finishVerification = 'caseManagement.cases.finishVerification.label',
  rejectCase = 'caseManagement.cases.rejectCase.label',
  summaryReport = 'caseManagement.cases.summaryReport.label',
  caseIdOrName = 'caseManagement.cases.caseIdOrName.label',
  assignedUsersUniqueIds = 'caseManagement.cases.assignedUsers.label',
  applicants = 'caseManagement.cases.applicants.label',
  caseStatuses = 'caseManagement.cases.caseStatuses.label',
  processTypes = 'caseManagement.cases.processTypes.label',
  licenceAuthorities = 'caseManagement.cases.licenceAuthorities.label',
  regions = 'caseManagement.cases.regions.label',
  summary = 'caseManagement.cases.summary.label',
  closeTaskText = 'caseManagement.cases.closeTask.text',
  legalName = 'caseManagement.cases.applicants.label',

  licencingAuthority = 'caseManagement.cases.licencingAuthority.label',
  showDetails = 'caseManagement.cases.showDetails.label',
  procesType = 'caseManagement.cases.procesType.label',
  paymentStatus = 'caseManagement.payment.paymentStatus.label',
  internalDescription = 'caseManagement.payment.internalDescription.label',
  internalDescriptionText = 'caseManagement.payment.internalDescription.text',

  addCase = 'caseManagement.cases.addCase.label',
  licenceCodeName = 'caseManagement.cases.licenceCodeName.label',
  licenceAuthority = 'caseManagement.cases.licenceAuthority.label',
  applicationFile = 'caseManagement.cases.applicationFile.label',
  selectLegalEntity = 'caseManagement.cases.selectLegalEntity.label',
  willUploadLetter = 'caseManagement.cases.willUploadLetter.label',
  documentSubtitle = 'caseManagement.cases.documentSubtitle.text',
  selectVariation = 'caseManagement.cases.selectVariation.label',
  startEndDate = 'caseManagement.cases.startEndDate.label',
  licenceNumber = 'caseManagement.cases.licenceNumber.label',
  licenceStatus = 'caseManagement.cases.licenceStatus.label',
  startDate = 'caseManagement.cases.startDate.label',
  endDate = 'caseManagement.cases.endDate.label',
  assetId = 'caseManagement.cases.assetId.label',
  assetsId = 'caseManagement.cases.assetsId.label',
  createdBy = 'caseManagement.cases.createdBy.label',
  assetsList = 'caseManagement.cases.assetsList.label',

  documentOfIdentity = 'caseManagement.cases.documentOfIdentity.label',
  documentCertificate = 'caseManagement.cases.documentCertificate.label',
  documentTest = 'caseManagement.cases.documentTest.label',
  documentUploadLater = 'caseManagement.cases.documentUploadLater.label',
  documentImportantNotice = 'caseManagement.cases.documentImportantNotice.label',
  documentSubtitle1ImportantNotice = 'caseManagement.cases.documentSubtitle1ImportantNotice.text',
  documentSubtitle2ImportantNotice = 'caseManagement.cases.documentSubtitle2ImportantNotice.text',
  documentSubtitle3ImportantNotice = 'caseManagement.cases.documentSubtitle3ImportantNotice.text',

  reviewCaseHeader = 'caseManagement.cases.headerReviewCase.label',
  reviewAndComment = 'caseManagement.cases.reviewAndComment.label',
  fileDetails = 'caseManagement.cases.fileDetails.label',
  notAssigned = 'caseManagement.cases.notAssigned.label',
  createLicence = 'caseManagement.cases.createLicence.label',
  varyLicence = 'caseManagement.cases.varyLicence.label',
  renewLicence = 'caseManagement.cases.renewLicence.label',
  verificationSummaryReport = 'caseManagement.cases.verificationSummaryReport.column',
  totalNumberOfComments = 'caseManagement.cases.totalNumberOfComments.label',
  caseStatusesUniqueIds = 'caseManagement.cases.caseStatuses.label',
  licenceAuthoritiesUniqueIds = 'caseManagement.cases.licenceAuthorities.label',
}

export const getBreadcrumbsBasic = (
  isFromLE: boolean,
  type: string | null,
  t: any,
  isOtherRequest?: boolean,
  leId?: string,
  expand?: string,
) => {
  return isFromLE
    ? [
        {
          label: t('module.legalEntity.name'),
          route: ERouteLinks.LegalEntities,
        },
        {
          label:
            type === ELegalEntityTypes.individual
              ? t('legalEntities.individual.accordion.label')
              : t('legalEntities.organization.accordion.label'),
          route: `${ERouteLinks.LegalEntities}?expand=${type}`,
        },
        {
          label: t('legalEntityDetails.legalEntityDetails.text'),
          route: `${ERouteLinks.ViewLegalEntity.replace(
            ':id',
            leId as string,
          )}?type=${type}&expand=${expand ?? 'cases'}`,
        },
      ]
    : [
        {
          label: t(ElabelsCaseManagement.caseManagementHeader),
          route: `${ERouteLinks.CaseManagementPage}?expand=${isOtherRequest ? ETabId.task : ETabId.applications}`,
        },
      ];
};

export const renderPaymentStatusFieldColor = (props: { paymentStatusUniqueId: string }) => {
  switch (props.paymentStatusUniqueId) {
    case EPaymentStatusId.PAID:
      return EChipsVariants.success;
    case EPaymentStatusId.REFUNDED:
      return EChipsVariants.primary;
    case EPaymentStatusId.UNPAID:
      return EChipsVariants.error;
    default:
      return EChipsVariants.primary;
  }
};

export const mapCasesToDataSource = (
  cases: ICase[],
  shortDateFormat: string,
  caseProcessTypes: IDictionary[] | null,
  weaponLicencingAuthority: IDictionary[] | null,
  weaponLicenceCaseStatus: IDictionary[] | null,
): ITableDataSource[] =>
  cases.map((item) => ({
    id: item.uniqueId,
    caseNumber: item.caseNumber,
    status: findInDictionary(item.statusUniqueId, weaponLicenceCaseStatus),
    statusUniqueId: item.statusUniqueId,
    legalName: item.legalName,
    legalUniqueId: item.legalUniqueId,
    legalType: item.legalType,
    processType: findInDictionary(item.processTypeUniqueId, caseProcessTypes),
    licencingAuthority: findInDictionary(
      item.licenceAuthorityUniqueId,
      weaponLicencingAuthority,
    ),
    licenceAuthorityUniqueId: item.licenceAuthorityUniqueId,
    createdDate: formatDate(item.createdDate, shortDateFormat),
    assignedTo: item.assignedTo,
  }));

interface ICasesTableColumns {
  handleShowDetails: (arg: string) => void;
  handleAssign: (arg: string) => void;
  canAssignCase: (licenceAuthorityUniqueId: string, statusUniqueId: string) => boolean;
  t: any;
}

export const casesTableColumns = ({
  handleShowDetails,
  handleAssign,
  canAssignCase,
  t,
}: ICasesTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f000',
    key: 'caseNumber',
    title: Elabels.caseID,
    width: '170px',
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f002',
    key: 'legalName',
    title: Elabels.legalEntityName,
    render: (_data, props) => (
      <Link
        href={`${ERouteLinks.ViewLegalEntity.replace(':id', props.legalUniqueId)}?type=${
          props.legalType === LETypes.individual
            ? ELegalEntityTypes.individual
            : ELegalEntityTypes.organisation
        }`}
        underline="none"
        target="_blank"
        rel="noopener noreferrer"
      >
        {props.legalName}
      </Link>
    ),
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f003',
    key: 'processTypeUniqueId',
    title: Elabels.procesType,
    render: (_data, props) => props.processType,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f009',
    key: 'licenceAuthorityUniqueId',
    title: Elabels.licencingAuthority,
    render: (_data, props) => props.licencingAuthority,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f004',
    key: 'createdDate',
    title: Elabels.createDate,
    render: (_data, props) => props.createdDate,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f005',
    key: 'statusUniqueId',
    title: Elabels.status,
    render: (_data, props) => (
      <Chips text={props.status} variant={renderStatusCaseFieldColor(props)} fullWidth />
    ),
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f006',
    key: 'assignedTo',
    title: Elabels.assignedTo,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f007',
    key: '',
    title: Elabels.actions,
    isSortable: false,
    align: 'center',
    isCenterTableHead: true,
    width: '80px',
    render: (_data, props) => (
      <MenuButton
        id={`menu_${props.id}`}
        items={[
          {
            name: t('caseManagement.cases.actions.details.label'),
            icon: EIconTypes.view,
            handler: () => {
              handleShowDetails(props.id);
            },
          },
          ...(canAssignCase(props.licenceAuthorityUniqueId, props.statusUniqueId)
            ? [
                {
                  name: t('caseManagement.cases.actions.assignTo.label'),
                  icon: EIconTypes.assignTo,
                  handler: () => {
                    handleAssign(props.id);
                  },
                },
              ]
            : []),
        ]}
      />
    ),
  },
];

export const mapAttachmentsToDataSource = (
  items: ICaseAttachmentResponse[],
  attachmentDocumentTypeData: IDictionary[] | null,
): ITableDataSource[] =>
  items.map((item) => ({
    id: item.uniqueId,
    name: findInDictionary(item.typeUniqueId, attachmentDocumentTypeData),
    importantNotice: item.importantNotice,
    attachments: item.attachments,
    typeUniqueId: item.typeUniqueId,
  }));

interface IAttachmentsTableColumns {
  downloadAll: (typeUniqueId: string, name: string) => void;
  uploadDocument: (id: string, name: string) => void;
  downloadDocument: (fileId: string, filename: string) => void;
  deleteDocument: (id: string) => void;
  t: any;
  isReadOnly?: boolean;
  isSupervisor?: boolean;
  isAssignUser?: boolean;
}

export const attachmentsTableColumns = ({
  downloadAll,
  uploadDocument,
  downloadDocument,
  deleteDocument,
  t,
  isReadOnly,
  isSupervisor,
  isAssignUser,
}: IAttachmentsTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f510',
    key: '',
    title: '',
    width: '50px',
    isSortable: false,
    render: (_data, props) =>
      props.attachments.length ? (
        <Icon type={EIconTypes.checkmarkSuccess} />
      ) : (
        <Icon type={EIconTypes.lightErrorWarning} />
      ),
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f511',
    key: 'name',
    isSortable: false,
    title: Elabels.documentName,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a7f32f512',
    key: 'importantNotice',
    title: Elabels.importanceNotice,
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f513',
    key: 'attachments',
    title: Elabels.filename,
    isSortable: false,
    minWidth: '350px',
    render: (_data, props) => (
      <Grid sx={{ gap: '2px' }}>
        {!props.attachments.length && (
          <Typography variant="body2" style={{ fontStyle: 'italic', color: colors.gray400 }}>
            {t(Elabels.noFilesAdded)}
          </Typography>
        )}
        {props.attachments.map((item: IAttachment) => (
          <Grid sx={{ display: 'flex', gap: 1 }}>
            <Link
              onClick={() => downloadDocument(item.uniqueId, item.name)}
              underline="none"
              rel="noopener noreferrer"
              style={{ display: 'flex', cursor: 'pointer', gap: '8px' }}
            >
              {`${item.name}.${item.extension}`}
              <Icon type={EIconTypes.downloadSmall} fontSize={20} />
            </Link>
            {!isReadOnly && (isAssignUser || isSupervisor) && (
              <Link
                onClick={() => deleteDocument(item.uniqueId)}
                underline="none"
                rel="noopener noreferrer"
                style={{ display: 'flex', cursor: 'pointer', gap: '8px' }}
              >
                <Icon type={EIconTypes.delete} fontSize={18} />
              </Link>
            )}
          </Grid>
        ))}
      </Grid>
    ),
  },
  {
    id: 'f0504ca5-6b32-482d-a269-304b6f32f515',
    key: '',
    width: '100px',
    align: 'center',
    title: 'general.actions.text',
    isCenterTableHead: true,
    justifyContentHead: 'center',
    isSortable: false,
    render: (_data, props) => (
      <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
        <Tooltip title={t(Elabels.downloadAll)}>
          <Button
            variant={EButtonVariants.outlined}
            tableButton
            icon={EIconTypes.download}
            onClick={() => downloadAll(props.typeUniqueId, props.name)}
            disabled={!props.attachments.length}
            id="helpers_download-button"
          />
        </Tooltip>
        {!isReadOnly && (isAssignUser || isSupervisor) && (
          <Tooltip title={t(Elabels.uploadDocument)}>
            <Button
              variant={EButtonVariants.outlined}
              tableButton
              icon={EIconTypes.addFile}
              onClick={() => uploadDocument(props.id, props.name)}
              id="helpers_add_file-button"
            />
          </Tooltip>
        )}
      </Grid>
    ),
  },
];

export const mapCommentsToDataSource = (
  comments: ITaskComment[],
  dateFormat: string,
  t: any,
): AccordionItem[] =>
  comments.map((item, key) => ({
    key: `comment-${key}`,
    title: `${t('general.added.label')} ${formatDate(item.createdDate, dateFormat)} ${t('general.by.label')} ${item.authorName}(${item.authorDisplayUniqueId})`,
    description: item.comment,
  }));

interface ICommentsTableColumns {
  shortDateFormat: string;
}

export const commentsTableColumns = ({
  shortDateFormat,
}: ICommentsTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f513',
    key: 'creationDate',
    title: Elabels.creationDate,
    isSortable: false,
    align: 'center',
    isCenterTableHead: true,
    render: (_data, props) =>
      `${props.creationDate ? formatDate(props.creationDate, shortDateFormat) : ''}`,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f511',
    key: 'message',
    title: Elabels.message,
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a7f32f512',
    key: 'author',
    title: Elabels.author,
    isSortable: false,
    align: 'center',
    isCenterTableHead: true,
  },
];

export const mapTasksToDataSource = (
  comments: ITask[],
  dateFormat: string,
): ITableDataSource[] =>
  comments.map((item) => ({
    id: item.uniqueId,
    task: item.name,
    status: item.status,
    statusUniqueId: item.statusUniqueId,
    lastAuthor: `${item.lastAuthorName}(${item.lastAuthorDisplayUniqueId})`,
    lastUpdate: item.lastUpdate ? formatDate(item.lastUpdate, dateFormat) : null,
    fromTemplate: item.fromTemplate,
  }));

interface ITasksTableColumns {
  viewAction: (id: string) => void;
  editAction: (id: string) => void;
  deleteAction: (id: string) => void;
  renderStatusFieldColor: (arg: ITableDataSource) => any;
  isAssigned: boolean;
  isReadOnly?: boolean;
}

export const tasksTableColumns = ({
  viewAction,
  editAction,
  deleteAction,
  renderStatusFieldColor,
  isAssigned,
  isReadOnly,
}: ITasksTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f511',
    key: '',
    title: '',
    width: '48px',
    isSortable: false,
    align: 'center',
    isCenterTableHead: true,
    render: (_data, props) =>
      props.statusUniqueId === ETaskStatus.DONE ? (
        <StyledIconWrapper>
          <Icon type={EIconTypes.checkmark} color={colors.success800} fontSize={16} />
        </StyledIconWrapper>
      ) : (
        <StyledIconWrapper error>
          <Icon type={EIconTypes.lightErrorWarning} color={colors.error700} fontSize={16} />
        </StyledIconWrapper>
      ),
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f512',
    key: 'name',
    title: Elabels.task,
    render: (_data, props) => props.task,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f513',
    key: 'lastUpdate',
    title: Elabels.lastUpdate,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f516',
    key: 'lastAuthorName',
    title: Elabels.lastAuthor,
    render: (_data, props) => props.lastAuthor,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f514',
    key: 'status',
    title: Elabels.status,
    align: 'center',
    isCenterTableHead: true,
    render: (_data, props) => (
      <Chips text={props.status} variant={renderStatusFieldColor(props)} />
    ),
  },
  {
    id: 'f0504ca5-6b32-482d-a269-304b6f32f515',
    key: '',
    width: '110px',
    align: 'center',
    title: 'general.actions.text',
    isCenterTableHead: true,
    isSortable: false,
    render: (_data, props) => (
      <>
        {!isReadOnly && isAssigned ? (
          <Button
            variant={EButtonVariants.outlined}
            tableButton
            icon={EIconTypes.view}
            onClick={() => editAction(props.id)}
            id={`edit_task-button-${props.id}`}
          />
        ) : (
          <Button
            variant={EButtonVariants.outlined}
            tableButton
            icon={EIconTypes.view}
            onClick={() => viewAction(props.id)}
            id={`view_task-button-${props.id}`}
          />
        )}
        {!isReadOnly &&
          !props.fromTemplate &&
          isAssigned &&
          props.statusUniqueId === ETaskStatus.WAITING && (
            <Button
              variant={EButtonVariants.outlined}
              tableButton
              icon={EIconTypes.delete}
              onClick={() => deleteAction(props.id)}
              id={`delete_task-button-${props.id}`}
            />
          )}
      </>
    ),
  },
];
export const mapRaportToDataSource = (
  comments: IReports[],
  dateFormat: string,
  t: any,
): ITableDataSource[] =>
  comments.map((item) => ({
    id: item.uniqueId,
    sourceSystem: item.sourceSystem,
    fromTemplate: item.fromTemplate,
    traceValue: item.trace,
    trace:
      item.trace === null ? '-' : item.trace ? t('general.yes.label') : t('general.no.label'),
    lastUpdate: item.lastUpdate ? formatDate(item.lastUpdate, dateFormat) : null,
    lastAuthor: `${item.lastAuthorName}(${item.lastAuthorDisplayUniqueId})`,
  }));

interface IRaportTableColumns {
  viewAction: (id: string) => void;
  deleteAction: (id: string) => void;
  addReportResult: (id: string) => void;
  isReadOnly?: boolean;
  showAdd?: boolean;
}

export const raportTableColumns = ({
  viewAction,
  deleteAction,
  addReportResult,
  isReadOnly,
  showAdd,
}: IRaportTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f511',
    key: '',
    title: '',
    width: '48px',
    isSortable: false,
    align: 'center',
    isCenterTableHead: true,
    render: (_data, props) =>
      props.traceValue !== null ? (
        <StyledIconWrapper>
          <Icon type={EIconTypes.checkmark} color={colors.success800} fontSize={16} />
        </StyledIconWrapper>
      ) : (
        <StyledIconWrapper error>
          <Icon type={EIconTypes.lightErrorWarning} color={colors.error700} fontSize={16} />
        </StyledIconWrapper>
      ),
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f512',
    key: 'sourceSystem',
    title: Elabels.sourceSystem,
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f514',
    key: 'trace',
    title: Elabels.trace,
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f515',
    key: 'lastUpdate',
    title: Elabels.lastUpdate,
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f513',
    key: 'lastAuthor',
    title: Elabels.lastAuthor,
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-a269-304b6f32f515',
    key: '',
    width: '110px',
    align: 'center',
    title: 'general.actions.text',
    isCenterTableHead: true,
    isSortable: false,
    render: (_data, props) => (
      <>
        <Button
          variant={EButtonVariants.outlined}
          tableButton
          icon={EIconTypes.view}
          onClick={() => viewAction(props.id)}
          id={`view_report-button-${props.id}`}
        />
        {!isReadOnly && showAdd && props.traceValue === null && (
          <Button
            variant={EButtonVariants.outlined}
            tableButton
            icon={EIconTypes.addFile}
            onClick={() => addReportResult(props.id)}
            id={`add_report_result-button-${props.id}`}
          />
        )}
        {!isReadOnly && showAdd && !props.fromTemplate && (
          <Button
            variant={EButtonVariants.outlined}
            tableButton
            icon={EIconTypes.delete}
            onClick={() => deleteAction(props.id)}
            id={`delete_report-button-${props.id}`}
          />
        )}
      </>
    ),
  },
];
export const mapNotesToDataSource = (
  comments: INote[],
  dateFormat: string,
): ITableDataSource[] =>
  comments.map((item) => ({
    id: item.uniqueId,
    notesName: item.name,
    lastUpdate: item.lastModifiedDate ? formatDate(item.lastModifiedDate, dateFormat) : null,
    lastAuthor: item.lastAuthor,
  }));

interface INotesTableColumns {
  viewAction: (id: string) => void;
  editAction: (id: string) => void;
  deleteAction: (id: string) => void;
  isReadOnly?: boolean;
}

export const notesTableColumns = ({
  viewAction,
  editAction,
  deleteAction,
  isReadOnly,
}: INotesTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f512',
    key: 'notesName',
    title: Elabels.notesName,
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f513',
    key: 'lastUpdate',
    title: Elabels.lastUpdate,
    isSortable: false,
    width: '200px',
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f514',
    key: 'lastAuthor',
    title: Elabels.lastAuthor,
    isSortable: false,
    width: '200px',
  },
  {
    id: 'f0504ca5-6b32-482d-a269-304b6f32f515',
    key: '',
    width: '110px',
    align: 'center',
    title: 'general.actions.text',
    isCenterTableHead: true,
    isSortable: false,
    render: (_data, props) => (
      <>
        <Button
          variant={EButtonVariants.outlined}
          tableButton
          icon={EIconTypes.view}
          onClick={() => viewAction(props.id)}
          id={`view_note-button-${props.id}`}
        />
        {!isReadOnly && (
          <Button
            variant={EButtonVariants.outlined}
            tableButton
            icon={EIconTypes.edit}
            onClick={() => editAction(props.id)}
            id={`edit_note-button-${props.id}`}
          />
        )}
        {!isReadOnly && (
          <Button
            variant={EButtonVariants.outlined}
            tableButton
            icon={EIconTypes.delete}
            onClick={() => deleteAction(props.id)}
            id={`delete_note-button-${props.id}`}
          />
        )}
      </>
    ),
  },
];
export const mapLicencesToDataSource = (
  items: ICaseLicence[],
  dateFormat: string,
  weaponLicenceStatus: IDictionary[] | null,
): ITableDataSource[] =>
  items.map((item) => ({
    id: item.uniqueId,
    licenceNumber: item.licenceNumber,
    statusUniqueId: item.statusUniqueId,
    status: findInDictionary(item.statusUniqueId, weaponLicenceStatus),
    startDate: item.startDate ? formatDate(item.startDate, dateFormat) : null,
    endDate: item.expiryDate ? formatDate(item.expiryDate, dateFormat) : null,
    assets: item.assets,
    assetCount: item.assetCount,
    createdDate: item.createdDate ? formatDate(item.createdDate, dateFormat) : null,
    createdBy: `${item.createdByName}(${item.createdByDisplayUniqueId})`,
  }));

interface ILicencesTableColumns {
  t: any;
  caseId: string;
  setModalAssetsData: (data: any) => void;
}

export const licencesTableColumns = ({
  t,
  caseId,
  setModalAssetsData,
}: ILicencesTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f512',
    key: 'licenceNumber',
    title: Elabels.licenceNumber,
    isSortable: false,
    width: '160px',
    render: (_data, props) => (
      <Link
        href={ERouteLinks.CaseDetailLicencePage.replace(':licenceId', props.id).replace(
          ':caseId',
          caseId,
        )}
        underline="none"
        target="_blank"
        rel="noopener noreferrer"
      >
        {props.licenceNumber}
      </Link>
    ),
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f513',
    key: 'statusUniqueId',
    title: Elabels.licenceStatus,
    isSortable: false,
    width: '150px',
    render: (_data, props) => (
      <Chips
        text={props.status}
        variant={renderLicenceDataColor(props)?.stateField}
        fullWidth
      />
    ),
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f523',
    key: 'startDate',
    title: Elabels.startDate,
    isSortable: false,
    width: '100px',
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f514',
    key: 'endDate',
    title: Elabels.endDate,
    isSortable: false,
    width: '110px',
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f515',
    key: 'assetId',
    title: Elabels.assetId,
    isSortable: false,
    width: '220px',
    render: (_data, props) => (
      <>
        {props.assets?.length > 0 ? (
          <Grid container>
            {props.assets.length === 1 && (
              <Link
                href={ERouteLinks.ViewRegisteredFirearm.replace(
                  ':id',
                  props.assets[0].uniqueId,
                )}
                underline="none"
                target="_blank"
                rel="noopener noreferrer"
              >
                {props.assets[0].fireCycleId}
              </Link>
            )}
            {props.assets.length > 1 && (
              <Link underline="none" style={{ cursor: 'pointer' }}>
                <div onClick={() => setModalAssetsData(props.assets)}>
                  {t('caseManagement.cases.displayAllAssets.label').replace(
                    '{0}',
                    props.assets.length,
                  )}
                </div>
              </Link>
            )}
          </Grid>
        ) : (
          '-'
        )}
      </>
    ),
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f516',
    key: 'createdDate',
    title: Elabels.createDate,
    isSortable: false,
    width: '110px',
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f516',
    key: 'createdBy',
    title: Elabels.createdBy,
    isSortable: false,
  },
];

export const mapHistoryToDataSource = (
  history: ICaseHistory[],
  dateFormat: string,
): ITableDataSource[] =>
  history.map((item) => ({
    id: item.uniqueId,
    createdDate: item.createdDate ? formatDate(item.createdDate, dateFormat) : '',
    status: item.caseStatus,
    statusUniqueId: item.caseStatusUniqueId,
    description: item.description,
    lastAuthor: item.authorName,
  }));

export const historyTableColumns = (): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-a169-304a6f32f514',
    key: 'createdDate',
    title: Elabels.dateTime,
    width: '160px',
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f512',
    key: 'status',
    title: Elabels.status,
    isSortable: false,
    width: '200px',
    justifyContentHead: 'center',
    isCenterTableHead: true,
    render: (_data, props) => (
      <Chips
        text={props.status}
        variant={renderStatusCaseFieldColor({ statusUniqueId: props.statusUniqueId })}
        fullWidth
      />
    ),
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f513',
    key: 'description',
    title: Elabels.description,
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f599',
    key: 'lastAuthor',
    title: Elabels.user,
    isSortable: false,
    width: '250px',
  },
];

export const initialCaseFormValues: ICaseFormValues = {
  legalName: '',
  legalUniqueId: '',
  licenceAuthorityUniqueId: '',
  paymentStatusUniqueId: '',
  processTypeUniqueId: '',
  licenceCodeName: '',
  applicationProcessUniqueId: '',
  applicationFiles: null,
  documents: null,
  documentWillUploadLetter: null,
  applicationsFilenames: [],
  documentsFilenames: null,
};
interface ISummaryReportTableColumns {
  handleView: () => void;
  handleDownload: () => void;
}

export const summaryReportTableColumns = ({
  handleView,
  handleDownload,
}: ISummaryReportTableColumns): ITableColumns[] => [
  {
    id: 'f0504ca5-6b32-482d-a169-304a8f32f512',
    key: 'name',
    title: Elabels.verificationSummaryReport,
    isSortable: false,
  },
  {
    id: 'f0504ca5-6b32-482d-a269-304a6f32f516',
    key: '',
    width: '100px',
    align: 'center',
    title: 'general.actions.button',
    isCenterTableHead: true,
    isSortable: false,
    render: (_data, props) => (
      <div>
        <Button
          id={`case_summary_report_view-button-${props.id}`}
          variant={EButtonVariants.outlined}
          tableButton
          icon={EIconTypes.view}
          onClick={handleView}
        />
        <Button
          id={`case_summary_report_download-button-${props.id}`}
          variant={EButtonVariants.outlined}
          tableButton
          icon={EIconTypes.download}
          onClick={handleDownload}
        />
      </div>
    ),
  },
];

export const getLicenceCaseRenewStatusText = (status: ECaseRenewalStatus | null = null) => {
  switch (status) {
    case ECaseRenewalStatus.EXISTS_NOT_FINISHED:
      return 'renewLicence.modal.existsNotFinished.text';
    case ECaseRenewalStatus.EXISTS_GRANTED:
      return 'renewLicence.modal.existsGranted.text';
    case ECaseRenewalStatus.EXISTS_DENIED:
      return 'renewLicence.modal.existsDenied.text';
    case ECaseRenewalStatus.NOT_EXISTS:
      return 'renewLicence.modal.notExists.text';
    case ECaseRenewalStatus.GENERIC_EXISTS_NOT_FINISHED:
      return 'modifyLicence.modal.genericExistsNotFinished.text';
    default:
      return '';
  }
};
export const getLicenceCaseVaryStatusText = (status: ECaseVariationStatus | null = null) => {
  switch (status) {
    case ECaseVariationStatus.EXISTS_NOT_FINISHED:
      return 'varyLicence.modal.existsNotFinished.text';
    case ECaseVariationStatus.EXISTS_GRANTED:
      return 'varyLicence.modal.existsGranted.text';
    case ECaseVariationStatus.EXISTS_DENIED:
      return 'varyLicence.modal.existsDenied.text';
    case ECaseVariationStatus.NOT_EXISTS:
      return 'varyLicence.modal.notExists.text';
    default:
      return '';
  }
};
